import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NoAccess } from '@/components/custom/no-access';
import { useMe } from '@/lib/me';

// Layout for /invoices/* — the invoice list, and the editor and approval queue
// that land on this stack. Gates every child on `invoice.view`.
//
// `invoice.view` rather than a broader module-level id: the settings screen is
// gated separately and much more narrowly, because its remittance block is a
// bank account. See docs/invoice-settings.md.
export const Route = createFileRoute('/_authenticated/invoices')({
  component: InvoicesLayout,
});

function InvoicesLayout() {
  const { permissions, loading } = useMe();
  if (!loading && !permissions.has('invoice.view')) {
    return <NoAccess permission="invoice.view" resource="Invoices" />;
  }
  return <Outlet />;
}
